import { GuardError } from '../../../errors/GuardError';
import { showAlert } from '../../../slices/alertSlice';
import { TThunkAction } from '../../../types/redux/thunk';
import { ETelemetryEvents } from '../../../types/telemetry';
import { setFirstMessageFailed } from '../actions';
import { EFirstMessageResponseStatus, IAssertDependencies, TFirstMessageResponse } from '../types';

export const assertUserCanNotChatWithHisColleaguesStatus =
  (response: TFirstMessageResponse, { domain, telemetry }: IAssertDependencies): TThunkAction<void> =>
  (dispatch, _, { logger }) => {
    if (response.status === EFirstMessageResponseStatus.UserCanNotChatWithHisColleagues) {
      telemetry.increment(ETelemetryEvents.ChatFirstMessageSendUserCanNotChatWithHisColleagues);

      dispatch(setFirstMessageFailed());
      dispatch(showAlert({ message: 'Вы не можете написать сообщение своему коллеге' }));

      const error = new GuardError({
        message: 'Не удалось отправить первое сообщение: получатель — коллега по мастер-аккаунту агентства',
        domain,
        details: { errorCode: response.status },
      });

      logger.error(error);
    }
  };
